import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { GuestGuard } from 'src/auth/guard';
// layouts
import AuthClassicLayout from 'src/layouts/auth/classic';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// JWT
const JwtHeightLoginView = lazy(() => import('src/pages/auth/jwt/login-height'));

// ----------------------------------------------------------------------

const authTHEJwt = {
  path: '',
  element: (
    <GuestGuard>
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    </GuestGuard>
  ),
  children: [
    {
      path: 'the-login',
      element: (
        <AuthClassicLayout>
          <JwtHeightLoginView />
        </AuthClassicLayout>
      ),
    }
  ],
};


export const authTHERoutes = [
  {
    path: '',
    children: [authTHEJwt],
  },
];
